import SOURCE from './design-token-surfaces.json' with { type: 'json' }

const deepFreeze = (value) => {
  for (const child of Object.values(value)) {
    if (child !== null && typeof child === 'object') deepFreeze(child)
  }
  return Object.freeze(value)
}

const SURFACES = deepFreeze(SOURCE)

export const FOCUS_ACCENTS = SURFACES.focusAccents

export const FOCUS_SURFACE_CASES = deepFreeze(
  ['light', 'dark'].flatMap((mode) =>
    ['ledger', 'folio'].flatMap((direction) =>
      SURFACES.directions[direction][mode].map((surface) => ({
        direction,
        mode,
        surface,
      }))
    )
  )
)

export default SURFACES
